module.exports = __webpack_public_path__ + "img/three_select_right.651c54ba.png";